module.exports = __webpack_public_path__ + "static/img/midautumn_lucky_bg.25bdf398.png";